import React from 'react';
import { Typography, TextField, Box } from '@mui/material';

export const NotesSection = ({
    notes,
    setNotes,
    intl,
}) => {
    return (
        <Box sx={{ mt: 5 }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
                {intl.get('AdditionalInfo').d('AdditionalInfo')}
            </Typography>
            <TextField
                label={intl.get('Notes').d('Notes')}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                fullWidth
                multiline
                rows={3}
                placeholder={intl.get('EnterAdditionalNotesPlaceholder').d('Enter any additional notes or observations...')}
                variant="outlined"
            />
        </Box>
    );
};
